<template>
  <v-card :flat="isFlat">
    <vue-perfect-scrollbar>
      <v-card-text class="customer-dues pa-0">
        <v-container grid-list-lg fluid>
          <v-layout row wrap>
            <table-skeleton :columns="4" :has-headers="true" v-if="isSearching">
            </table-skeleton>
            <v-data-table
              v-else
              :headers="headers"
              hide-actions
              class="w-100"
              no-data-text="No se encontraron datos"
              :items="rows"
              :pagination.sync="sorting">
              <template slot="headers" slot-scope="props">
                <th v-for="(header, index) in props.headers" :key="`header-${index}`" :class="{ [header.class]: true }">
                  <v-icon class="k-orange-linear-text mr-2">{{ header.icon }}</v-icon>
                  <span>
                    {{ header.text }}
                  </span>
                </th>
              </template>
              <template slot="items" slot-scope="props">
                <tr>
                  <td>
                    {{ props.item.descrip }}
                  </td>
                  <td>
                    {{ props.item.due_date | formatDate }}
                  </td>
                  <td>
                    {{ props.item.invoiced_balance | formatNumber }}
                  </td>
                  <td>
                    {{ props.item.due_balance | formatNumber }}
                  </td>
                  <td class="text-xs-center">
                    <v-btn flat icon @click="expandRow(props)">
                      <v-icon small>fa-chevron-down</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template slot="expand" slot-scope="props" colspan="4">
                <vue-perfect-scrollbar class="sub-table" :settings="{ suppressScrollX: true }">
                  <v-layout row wrap style="height: 150px;">
                    <v-flex xs12>
                      <table class="sub-table">
                        <thead>
                          <tr>
                            <th v-for="(head, idx) in Object.keys(props.item.detailed)" :key="`sub-table-${idx}`">
                              {{ head }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td v-for="(key, i) in Object.keys(props.item.detailed)" :key="`detail-column-${i}`">
                              <ul>
                                <li class="mb-2" v-for="(item, itemIndex) in props.item.detailed[key]" :key="`detail-item-${itemIndex}`">
                                  <span v-if="item.type === 'amount'">
                                    {{ item.value | formatNumber }}
                                  </span>
                                  <span v-else-if="item.type === 'date'">
                                    {{ item.value | formatDate }}
                                  </span>
                                  <span v-else>
                                    {{ item.value }}
                                  </span>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </v-flex>
                  </v-layout>
                </vue-perfect-scrollbar>
              </template>
            </v-data-table>
          </v-layout>
        </v-container>
      </v-card-text>
    </vue-perfect-scrollbar>
  </v-card>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import moment from 'moment';
import _ from 'lodash';
import TableSkeleton from '@/components/global/skeletons/TableSkeleton';

export default {
  components: {
    VuePerfectScrollbar,
    TableSkeleton,
  },
  props: {
    customer: {
      type: Object,
      default: () => {},
    },
    tab: {
      type: String,
      default: 'tab-4',
    },
    isFlat: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: 'company_id,customer_id,account,number,due_date,delinquency,descrip,details,due_balance,invoiced_balance,created_at',
      data: [],
      headers: [
        {
          text: 'Descripción',
          icon: 'fa-clipboard-list',
          class: 'text-xs-left',
          value: 'descrip',
        },
        {
          text: 'Fecha',
          icon: 'fa-calendar-alt',
          class: 'text-xs-left',
          value: 'due_date',
        },
        {
          text: 'Facturado',
          icon: 'fa-file-invoice',
          class: 'text-xs-left',
          value: 'invoiced_balance',
        },
        {
          text: 'Deuda',
          icon: 'fa-hand-holding-usd',
          class: 'text-xs-left',
          value: 'due_balance',
        },
        {
          text: 'Detalles',
          icon: 'fa-list',
          class: 'text-xs-left',
          value: 'detail',
        },
      ],
      sorting: {
        sortBy: 'due_date',
        descending: true,
        rowsPerPage: -1,
      },
      isSearching: false,
    };
  },
  computed: {
    rows() {
      return this.data.map((item) => {
        /* eslint-disable */
        item.details = JSON.parse(item.details);
        /* eslint-disable */
        item.detailed = _.mapValues(_.groupBy(_.flatten(item.details), 'name'),
          details => details.map(detail => _.omit(detail, 'name')));
        // item.detailsHeaders = _.uniqBy(_.flatten(item.details), 'name').map((detail) => detail.name);
        return item;
      });
    },
  },
  filters: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    formatNumber(value) {
      return new Intl.NumberFormat('es-VE', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(value);
    },
  },
  methods: {
    expandRow(props) {
      /* eslint-disable */
      props.expanded = !props.expanded;
      if (props.expanded) {
        this.due = this.data[props.index];
      }
    },
    fetchDues() {
      this.data = [];
      this.isSearching = true;
      this.axios.get(`customers/${this.customer.id}/dues?fields=${this.fields}&paginate=0`).then(({ data }) => {
        this.data = data;
        this.isSearching = false;
      }).catch(() => {
        this.isSearching = false;
      });
    },
  },
  watch: {
    tab: {
      immediate: true,
      handler(value) {
        if (this.customer && value === 'tab-4') {
          this.fetchDues();
        }
      }
    },
  },
};
</script>
<style scoped>
  .customer-dues {
    height: 392px;
  }
  .customer-dues >>> .datatable.table {
    table-layout: fixed;
  }
  .customer-dues >>> .datatable.table td {
    padding-top: 6px !important;
    padding-bottom: 6px !important; 
    padding-right: 0px !important;
    word-break: break-all;
    white-space: normal !important;
  }
  .customer-dues >>> table.table tbody tr:first-child {
    border-top: 1px solid rgba(0,0,0,.12) !important;
  }
  .customer-dues >>> table.table tbody tr:not(:last-child):not(.datatable__expand-row) {
    border-bottom: 1px solid rgba(0,0,0,.12) !important;
  }
  .customer-dues >>> table.table tbody tr.datatable__expand-row .datatable__expand-col {
    padding-left: 0 !important;
  }
  .customer-dues >>> table.table tbody tr.datatable__expand-row .datatable__expand-col--expanded .datatable__expand-content {
    border-bottom: 1px solid rgba(0,0,0,.12) !important;
  }
  .sub-table {
    width: 100%;
  }
  .sub-table th {
    text-align: left;
  }
  .sub-table td {
    padding: 16px !important;
  }
  .sub-table td ul {
    padding: 0;
    list-style: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/customer/CustomerDues.vue